import "../App.css";
import teamPic from "../Assets/TeamPicture2025.png";
import React, { useEffect, useState } from "react";

function formatDate(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

function formatContent(content) {
  if (!content) return null;
  const lines = content.split("\n").filter((line) => line.trim() !== "");
  return (
    <div>
      {lines.map((line, idx) => {
        const parts = line.split(/(https?:\/\/[^\s]+)/g);
        const linkedLine = parts.map((part, i) =>
          /^https?:\/\//.test(part) ? (
            <a
              key={i}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#3a4edc" }}
            >
              {part}
            </a>
          ) : (
            part
          )
        );
        return (
          <div
            key={idx}
            style={
              idx === 0
                ? { fontWeight: "bold", marginBottom: "0.5em" }
                : { marginBottom: "0.5em" }
            }
          >
            {linkedLine}
          </div>
        );
      })}
    </div>
  );
}

function HeroSection() {
  const [topStories, setTopStories] = useState([]);
  const [openIds, setOpenIds] = useState({});

  useEffect(() => {
    fetch("https://wyrowingbackend.onrender.com/news")
      .then((res) => res.json())
      .then((data) => {
        const tops = data.filter((item) =>
          item.title.toLowerCase().includes("top")
        );
        setTopStories(tops);
      });
  }, []);

  useEffect(() => {
    // Re-render the Facebook plugin after navigation/render
    const interval = setInterval(() => {
      if (window.FB && window.FB.XFBML) {
        window.FB.XFBML.parse();
        clearInterval(interval);
      }
    }, 300);
    return () => clearInterval(interval);
  }, []);

  const toggleOpen = (id) => {
    setOpenIds((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className="content">
      <h1
        style={{
          color: "#162278",
          fontWeight: "bold",
          textAlign: "center",
          fontSize: "2.2rem",
          marginBottom: "1.5rem",
        }}
      >
        Wyandotte Bear Crew
      </h1>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginBottom: "2rem",
        }}
      >
        <img
          src={teamPic}
          alt="Wyandotte Rowing Team 2025"
          style={{
            maxWidth: "1000px",
            width: "100%",
            borderRadius: "12px",
            boxShadow: "0 4px 24px rgba(22,22,116,0.08)",
            objectFit: "cover",
          }}
        />
      </div>

      <h1
        style={{
          color: "#161674",
          fontWeight: "bold",
          fontSize: "2rem",
          marginBottom: "1rem",
          textAlign: "center",
        }}
      >
        Latest from Facebook
      </h1>
      <div
        className="facebook-feed-container"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div
          className="fb-page"
          data-href="https://www.facebook.com/profile.php?id=100057528674923"
          data-tabs="timeline, events, messages"
          data-width="600"
          data-height="600"
          data-small-header="true"
          data-adapt-container-width="false"
          data-hide-cover="true"
          data-show-facepile="true"
        >
          <blockquote
            cite="https://www.facebook.com/profile.php?id=100057528674923"
            className="fb-xfbml-parse-ignore"
          >
            <a href="https://www.facebook.com/profile.php?id=100057528674923">
              Wyandotte Roosevelt Rowing
            </a>
          </blockquote>
        </div>
      </div>

      <div className="hero-container">
        <video autoPlay loop muted className="bg-video">
          <source src="/RowingVideo.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-content">
          <h1>Welcome to Wyandotte Roosevelt High School Rowing</h1>
          <p>Established 1941</p>
          <p>Home of the Bear Crew!</p>
        </div>
      </div>

      {topStories.length > 0 && (
        <section
          style={{
            background: "#ffffff",
            borderRadius: "1px",
            borderColor: "#161674",
            maxWidth: "1000px",
            alignContent: "center",
            padding: ".5rem 2rem",
            marginBottom: ".5rem",
          }}
        >
          <h1
            style={{
              color: "#161674",
              fontWeight: "bold",
              fontSize: "2rem",
              marginBottom: "1rem",
              textAlign: "center",
            }}
          >
            Hot Off the Press!
          </h1>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {topStories
              .slice()
              .sort((a, b) => b.date.localeCompare(a.date))
              .map((item) => (
                <li
                  key={item.id}
                  style={{
                    marginBottom: "1.5rem",
                    borderLeft: "4px solid #162278",
                    paddingLeft: "1rem",
                    background: "#ffffff",
                    borderRadius: "1px",
                    cursor: "pointer",
                    transition: "background 150ms ease-in-out",
                  }}
                  onClick={() => toggleOpen(item.id)}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span
                      style={{ fontWeight: "bold", fontSize: "1rem", flex: 1 }}
                    >
                      {item.title
                        .replace("Top", "")
                        .replace("Story", "")
                        .trim()}
                    </span>
                    <span
                      style={{
                        marginLeft: "1rem",
                        fontSize: "1.2rem",
                        color: "#162278",
                      }}
                    >
                      {openIds[item.id] ? "▲" : "▼"}
                    </span>
                  </div>
                  <span style={{ color: "#162278", fontSize: "0.95rem" }}>
                    {formatDate(item.date)}
                  </span>
                  {openIds[item.id] && (
                    <div
                      style={{
                        margin: "0.75rem 0 0.5rem 0",
                        color: "#333",
                        background: "#f4f6fa",
                        padding: "0.75rem",
                        borderRadius: "6px",
                        fontSize: ".75rem",
                        maxHeight: "40em",
                        overflow: "auto",
                      }}
                    >
                      {formatContent(item.content || item.summary)}
                      <div style={{ marginTop: "1em" }}>
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#3a4edc",
                            textDecoration: "underline",
                            fontWeight: "bold",
                          }}
                        >
                          View Full Document
                        </a>
                      </div>
                    </div>
                  )}
                </li>
              ))}
          </ul>
        </section>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "2rem",
        }}
      >
        <a
          href="https://www.instagram.com/wyandotterowing/?hl=en"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#161674", fontWeight: "bold", fontSize: "1.2rem" }}
        >
          Follow us on Instagram
        </a>
      </div>
    </div>
  );
}

export default HeroSection;
